import { render, staticRenderFns } from "./CargoInsured.vue?vue&type=template&id=0ce658cd&"
import script from "./CargoInsured.vue?vue&type=script&lang=js&"
export * from "./CargoInsured.vue?vue&type=script&lang=js&"
import style0 from "./CargoInsured.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoInsured.vue"
export default component.exports